export const SERVER_API_URL = 'http://81.2.240.249:8080';
// export const SERVER_API_URL = 'http://81.2.240.249:8081';
// export const SERVER_API_URL = 'http://localhost:8080';
export const SERVER_API_URL_NEW = 'http://81.2.240.249:8080/api';
// export const SERVER_API_URL_NEW = 'http://81.2.240.249:8081/api';
// export const SERVER_API_URL_NEW = 'http://localhost:8080/api';
